import { actions, WatchlistsStore, WATCHLISTS_STORE_NAME } from './store';
import { LocationType, ResourceKey, frontendActions } from '@cmctechnology/webinvest-store-frontend';
import { CmcWebApi, IWebApiRequestBody } from '@cmctechnology/webinvest-api-client-web-trading';
import { Dispatch } from '@reduxjs/toolkit';
import { WATCHLIST_API_NAMES } from './apiNames';
import { CloudApi } from './types';

type GetState = typeof WatchlistsStore.getState;

const THEMATIC_WATCHLISTS_POLL_TIMEOUT = 30_000;

export const fetchThematicWatchlists = (refresh: boolean = false) => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const hash = refresh ? 0 : getState()[WATCHLISTS_STORE_NAME].thematicListsHash;
    const request: IWebApiRequestBody = {
      _config: { hash }
    };
    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Watchlists.ThematicWatchlistsResponseModel1>(
        WATCHLISTS_STORE_NAME,
        WATCHLIST_API_NAMES.ThematicWatchlistsGet1,
        request,
        dispatch,
        hash,
        refresh,
        true
      );
      dispatch(actions.thematicWatchlistsFetched({ response, listsHash: response._apiInfo?.Hash ?? 0 }));
    } catch {}
  };
};

export const fetchThematicWatchlist = (id: number, refresh: boolean = false) => {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const item = getState()[WATCHLISTS_STORE_NAME].thematicItems?.[id];
    const hash = refresh ? 0 : (item?.hash ?? 0);
    const request: CmcWebApi.Watchlists.ThematicWatchlistRequest1 & IWebApiRequestBody = {
      Id: id as number,
      _config: { hash }
    };

    try {
      const response = await frontendActions.webTradingApiCall<CmcWebApi.Watchlists.ThematicWatchlistDetailResponseModel1>(
        WATCHLISTS_STORE_NAME,
        WATCHLIST_API_NAMES.ThematicWatchlistGet1,
        request,
        dispatch,
        id,
        refresh,
        true
      );
      dispatch(actions.thematicWatchlistFetched({ id: id as number, response, hash: response._apiInfo?.Hash ?? 0 }));
    } catch {}
  };
};

export const fetchCloudThematicWatchlists = () => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await frontendActions.cloudApiCall<CloudApi.EmptyBodyModel, CloudApi.SystemWatchlistDto[]>(
        WATCHLISTS_STORE_NAME,
        WATCHLIST_API_NAMES.CloudThematicWatchlistsGet1,
        {},
        dispatch
      );
      dispatch(actions.cloudThematicWatchlistsFetched(response.data));
    } catch {}
  };
};

export const fetchCloudThematicWatchlist = (id: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      const response = await frontendActions.cloudApiCall<CloudApi.RetrieveSystemWatchlistByIdModel, CloudApi.SystemWatchlistFullDetailsDto>(
        WATCHLISTS_STORE_NAME,
        WATCHLIST_API_NAMES.CloudThematicWatchlistGet1,
        {
          id: id as string
        },
        dispatch,
        id
      );
      dispatch(actions.cloudThematicWatchlistFetched(response.data));
    } catch {}
  };
};

export const onPollFetchThematicWatchlists =
  (subscriptions: ResourceKey[] = []) =>
  (dispatch: Dispatch<any>) => {
    if (subscriptions.length > 0) {
      dispatch(fetchThematicWatchlists());
    }
  };

// TODO: Do not poll
export const subscribeThematicWatchlists = (location: LocationType) => (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.subscribe({
      onPoll: onPollFetchThematicWatchlists,
      location,
      apiName: WATCHLIST_API_NAMES.ThematicWatchlistsGet1,
      storeName: WATCHLISTS_STORE_NAME,
      pollTimeout: THEMATIC_WATCHLISTS_POLL_TIMEOUT
    })
  );
};

export const unsubscribeThematicWatchlists = (location: LocationType) => (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.unsubscribe({
      location,
      apiName: WATCHLIST_API_NAMES.ThematicWatchlistsGet1,
      storeName: WATCHLISTS_STORE_NAME
    })
  );
};

export const onPollFetchThematicWatchlist =
  (subscriptions: ResourceKey[] = []) =>
  (dispatch: Dispatch<any>) => {
    subscriptions.forEach((id) => {
      dispatch(fetchThematicWatchlist(Number(id)));
    });
  };

export const subscribeThematicWatchlist = (location: LocationType, id: number) => (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.subscribe({
      onPoll: onPollFetchThematicWatchlist,
      location,
      apiName: WATCHLIST_API_NAMES.ThematicWatchlistGet1,
      storeName: WATCHLISTS_STORE_NAME,
      resourceKeys: [id],
      pollTimeout: THEMATIC_WATCHLISTS_POLL_TIMEOUT
    })
  );
};

export const unsubscribeThematicWatchlist = (location: LocationType, id: number) => (dispatch: Dispatch<any>) => {
  dispatch(
    frontendActions.unsubscribe({
      location,
      apiName: WATCHLIST_API_NAMES.ThematicWatchlistGet1,
      storeName: WATCHLISTS_STORE_NAME,
      resourceKeys: [id]
    })
  );
};
